/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Stable grouping modes supported by the Dependencies tab.
 */
export enum RoadmapDependencyView {
    DELIVERING_GROUP = 'delivering_group',
    REQUESTING_GROUP = 'requesting_group',
    SUB_WORKSTREAM = 'sub_workstream',
    STATUS = 'status',
    PRIORITY = 'priority',
    ACTION_NEEDED = 'action_needed',
}
